import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { ProductGroupService } from '../product-group.service';
import { ProductsService } from '../../products/products.service';
import {Form, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CatalogService} from '../../catalogs/catalog.service';
import {RxComponent} from '../../../../../core/components/common/rx.component';
import {BrandService} from '../../brands/brand.service';

declare var $: any;
@Component({
  selector: 'itpx-product-group-add',
  templateUrl: './product-group-add.component.html',
  styleUrls: ['./product-group-add.component.css']
})
export class ProductGroupAddComponent extends RxComponent implements OnInit {

    @ViewChild('subtopicsWrapper') subtopicsWrapper: ElementRef;
    private keywords: any;
    private domains: any;
    private categoryFamilies: any;
    private brands: Array<any>;
    private categories: any;
    private subTopics: any;

    productGroupForm: FormGroup;

    constructor(
        private service: ProductGroupService,
        private productService: ProductsService,
        private productsService: ProductsService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router,
        private fb: FormBuilder,
        private catalogService: CatalogService,
        private brandService: BrandService
    ) {
        super();
    }

    ngOnInit() {

        this.keywords = this.catalogService.keywordsSource;
        this.productService.getDomainDict()
            .subscribe(
                body => {
                    this.domains = body.data;
                }
            )
        this.productService.getCategoryFamilyDict()
            .subscribe(
                body => {
                    this.categoryFamilies = body.data;
                }
            );
        this.brandService.getBrandList()
            .subscribe(
                body => {
                    this.brands = this.brandService.formatBrandsToDict(body['data']);
                }
            );
        this.service.getCategories()
            .subscribe(
                body => {
                    this.categories = body['data'];
                }
            );

        this.productGroupForm = this.fb.group({
            name: [null, [Validators.required, Validators.maxLength(255)]],
            code: [null, [Validators.required, Validators.maxLength(255)]],
            keywords: [null],
            description: [null, Validators.maxLength(1500)],
            domains: [null],
            categoryFamily: [null],
            brand: [null],
            category: [null, Validators.required],
            subTopics: [null]
        });

        this.productGroupForm.controls.category.valueChanges
            .subscribe(change => {
                if (change) {
                    this.service.getSubtopics(change)
                        .subscribe(
                            body => {
                                this.subTopics = this.extractDictionary(body['data']);
                                if(this.subTopics && this.subTopics.length) {
                                    $(this.subtopicsWrapper.nativeElement).removeClass('hidden', 1000);
                                }
                            }
                        )
                }
            });
    }

    private extractDictionary(dto: any) {
        let result;
        if (Array.isArray(dto)) {
            result = [];
            dto.forEach(el => {
                if(el.hasOwnProperty('id')) {
                    result.push({
                        key: el['id'],
                        value: el['title']
                    })
                }
            })
        } else {
            result = dto;
        }
        return result;
    }

    private onSaveFinished() {
        this.service.add(this.productsService.formatData(this.productGroupForm.getRawValue()))
        .subscribe(
            body => {
                const response = body['data'];
                this.notificationService.success('Successfully created the product group', 'Success');
                this.router.navigate(['/agora/product-data/product-groups/']);
            }
        );
    }
    private onChangeBrand(brandId: any) {
        this.productGroupForm.patchValue({
            brand: brandId
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-groups/add/product-group-add.component.ts